var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRightNarrow = function SvgArrowRightNarrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.187 7.186a1.15 1.15 0 0 1 1.627 0l4 4a1.1 1.1 0 0 1 .2.272 1.1 1.1 0 0 1 .114.32q.033.169.017.338a1.1 1.1 0 0 1-.062.266 1 1 0 0 1-.07.16q-.011.02-.024.04-.071.125-.175.231l-4 4a1.15 1.15 0 0 1-1.627-1.626l1.694-1.695a.2.2 0 0 0-.141-.342H3a1.15 1.15 0 0 1 0-2.3h14.74a.2.2 0 0 0 .141-.342l-1.694-1.695a1.15 1.15 0 0 1 0-1.627"
  })));
};
export default SvgArrowRightNarrow;